
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericAnchoredFilled as ObiVesselGenericAnchoredFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-anchored-filled.js';
 
 
 

 
 export const ObiVesselGenericAnchoredFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-anchored-filled',
   elementClass: ObiVesselGenericAnchoredFilledElement,
   events: {
     
   }
  });
 
 